import api from "./api.service";

/* ─── Tipos (respuestas de /api/notificaciones, ver back saas-api/src/notificaciones) ───
   Panel del Tribunal de Contrataciones (tabla public.notificaciones de la base
   `oece`, leída en solo lectura por el backend Node). Lo ve SOLO el rol
   NOTIFICACIONES: el backend lo exige con requireRole. Portado de dashboard.py. */

export interface NotifStats {
  total: number;
  inicios: number;
  con_pdf: number;
  por_tipo: { tipo: string; n: number }[];
  por_etapa: { etapa: string; n: number }[];
}

export interface NotifRow {
  idnotifica: number;
  es_inicio_sancion: boolean;
  tipo_expediente: string | null;
  etapa: string | null;
  confianza: string | null;
  n_expediente: string | null;
  fecha_decreto: string | null;
  ruc: string | null;
  nombre_original: string | null;
  url_pdf: string | null;
  url_pagina: string | null;
}

export interface NotifFiltros {
  tipo?: string;
  etapa?: string;
  q?: string;
  inicio?: boolean;
  limit?: number;
}

export const getNotifStats = () => api.get<NotifStats>("/notificaciones/stats");

export const getNotifRows = (params: NotifFiltros) =>
  api.get<NotifRow[]>("/notificaciones/rows", { params });

/* ─── Leads: un decreto de INICIO de PAS por fila (/api/notificaciones/leads) ───
   El contacto lo carga el estudio a mano por RUC (tabla lead_contacto del back). */

export interface LeadContacto {
  ruc: string;
  telefono: string | null;
  nota: string | null;
  actualizado_en: string;
}

export interface LeadDenunciado {
  nombre: string;
  ruc: string | null;
  dni: string | null;
  contacto: LeadContacto | null;
}

export interface Lead {
  idnotifica: number;
  n_notificaciones: number;
  n_expediente: string | null;
  n_decreto: string | null;
  fecha_decreto: string | null;
  entidad: string | null;
  infraccion: string | null;
  denunciados: LeadDenunciado[];
  url_pdf: string | null;
  vence_aprox: string | null;            // estimado: notificación +1 día hábil, +10 días hábiles
  dias_habiles_restantes: number | null; // -1 = ya venció
}

export const getLeads = (params: { q?: string; tipo_ruc?: "10" | "20" }) =>
  api.get<Lead[]>("/notificaciones/leads", { params });

export const guardarContacto = (ruc: string, datos: { telefono: string; nota: string }) =>
  api.put<LeadContacto>(`/notificaciones/contactos/${ruc}`, datos);
